import { GAME_TYPE } from "constants/game.constants";
import { createContext } from "react";

const favoriteGamesContextDefaultValue = Object.values(GAME_TYPE).reduce((acc, gameType) => {
	acc[gameType] = 0;
	return acc
}, {})

const favoriteMarketsContextDefaultValue = Object.values(GAME_TYPE).reduce((acc, gameType) => {
	acc[gameType] = {};
	return acc
}, {})

const contextDefaultValue = {
	favoriteGames: favoriteGamesContextDefaultValue,
	favoriteMarkets: favoriteMarketsContextDefaultValue
}

const FavoriteResourceSortingContext = createContext(contextDefaultValue);
FavoriteResourceSortingContext.displayName = "FavoriteResourceSortingContext";
export default FavoriteResourceSortingContext;
